const education = [
  {
    degree: "B.TECH MECHANICAL ENGINEERING",
    institution: "BIHAR ENGINEERING UNIVERSITY",
    period: "2019 – 2023",
    grade: "74.4%",
    description: "Bachelor of Technology in Mechanical Engineering"
  },
  {
    degree: "HIGHER SECONDARY (CBSE)",
    institution: "SKP VIDYA VIHAR",
    period: "2017 – 2019",
    grade: "72.2%",
    description: "Higher Secondary Education with CBSE board"
  },
  {
    degree: "SECONDARY (ICSE)",
    institution: "SAINT TERESA'S SCHOOL",
    period: "2016 – 2017",
    grade: "89.66%",
    description: "Secondary Education with ICSE board"
  }
];

export default education;